export default {
	"description": "识别成功",
	"error_code": 0,
	"recognize_time": 991,
	"request_id": "ec66d05a4fc711eb9a7d00163e0d18d7",
	"result": [{
		"column_info": ["项目", "金额", "金额", "金额", "金额"],
		"data": [
			[{
				"quad": "85,203,174,203,174,217,85,217",
				"score": 1.0,
				"words": "一、营业总收入"
			}, {
				"quad": "403,199,492,199,492,211,403,211",
				"score": 1.0,
				"words": "197,705,751.76"
			}, {
				"quad": "513,199,602,195,603,209,514,213",
				"score": 1.0,
				"words": "197,958,458.17"
			}, {
				"quad": "624,197,715,197,715,209,624,209",
				"score": 1.0,
				"words": "200,471,766.22"
			}, {
				"quad": "738,197,839,194,839,208,738,211",
				"score": 1.0,
				"words": "1,067,338,135.41"
			}],
			[{
				"quad": "83,225,174,225,174,239,83,239",
				"score": 1.0,
				"words": "其中：营业改入"
			}, {
				"quad": "403,221,492,221,492,233,403,233",
				"score": 1.0,
				"words": "197,705,751.76"
			}, {
				"quad": "513,221,603,221,603,233,513,233",
				"score": 1.0,
				"words": "197,958,458.17"
			}, {
				"quad": "623,221,715,218,715,231,624,235",
				"score": 1.0,
				"words": "200,471,766.22"
			}, {
				"quad": "738,219,839,219,839,231,738,231",
				"score": 1.0,
				"words": "1,067,338,135.41"
			}],
			[{
				"quad": "83,249,174,249,174,261,83,261",
				"score": 1.0,
				"words": "二、营业总成本"
			}, {
				"quad": "403,245,492,245,492,255,403,255",
				"score": 1.0,
				"words": "188,909,278.51"
			}, {
				"quad": "513,243,603,243,603,255,513,255",
				"score": 1.0,
				"words": "192,659,543.71"
			}, {
				"quad": "625,244,714,244,714,254,625,254",
				"score": 1.0,
				"words": "193,449,090.94"
			}, {
				"quad": "738,241,841,241,841,253,738,253",
				"score": 1.0,
				"words": "1,091,413,577.02"
			}],
			[{
				"quad": "83,271,176,271,176,283,83,283",
				"score": 1.0,
				"words": "其中：营业成本"
			}, {
				"quad": "403,267,492,267,492,279,403,279",
				"score": 1.0,
				"words": "186,226,790.61"
			}, {
				"quad": "513,265,603,265,603,277,513,277",
				"score": 1.0,
				"words": "186,549,354.71"
			}, {
				"quad": "626,265,715,265,715,277,626,277",
				"score": 1.0,
				"words": "192,872,678.57"
			}, {
				"quad": "738,264,841,262,841,275,738,278",
				"score": 1.0,
				"words": "1,064,297,599.35"
			}],
			[{
				"quad": "83,293,176,293,176,305,83,305",
				"score": 1.0,
				"words": "营业税金及附加"
			}, {
				"quad": "469,289,496,289,496,301,469,301",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "579,287,606,287,606,299,579,299",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "690,287,717,287,717,299,690,299",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "802,285,841,285,841,297,802,297",
				"score": 1.0,
				"words": "616.21"
			}],
			[{
				"quad": "83,315,136,315,136,327,83,327",
				"score": 1.0,
				"words": "销售费用"
			}, {
				"quad": "430,311,494,311,494,321,430,321",
				"score": 1.0,
				"words": "437,232.16"
			}, {
				"quad": "541,309,605,309,605,321,541,321",
				"score": 1.0,
				"words": "536,516.87"
			}, {
				"quad": "651,309,715,309,715,321,651,321",
				"score": 1.0,
				"words": "220,904.77"
			}, {
				"quad": "763,309,841,309,841,319,763,319",
				"score": 1.0,
				"words": "3,656,969.94"
			}],
			[{
				"quad": "83,337,136,337,136,349,83,349",
				"score": 1.0,
				"words": "管理费用"
			}, {
				"quad": "430,333,494,333,494,345,430,345",
				"score": 1.0,
				"words": "410,886.10"
			}, {
				"quad": "527,331,605,331,605,343,527,343",
				"score": 1.0,
				"words": "1,129,785.63"
			}, {
				"quad": "651,331,717,331,717,343,651,343",
				"score": 1.0,
				"words": "295,796.46"
			}, {
				"quad": "763,329,843,329,843,341,763,341",
				"score": 1.0,
				"words": "3,521,028.12"
			}],
			[{
				"quad": "83,359,136,359,136,373,83,373",
				"score": 1.0,
				"words": "财务费用"
			}, {
				"quad": "417,355,494,355,494,367,417,367",
				"score": 1.0,
				"words": "1,834,369.64"
			}, {
				"quad": "527,353,605,353,605,365,527,365",
				"score": 1.0,
				"words": "4,443,886.50"
			}, {
				"quad": "657,353,717,353,717,365,657,365",
				"score": 1.0,
				"words": "59,711.14"
			}, {
				"quad": "758,353,843,350,843,363,758,366",
				"score": 1.0,
				"words": "19,934,847.85"
			}],
			[{
				"quad": "85,381,163,381,163,395,85,395",
				"score": 1.0,
				"words": "资产减值损失"
			}, {
				"quad": "469,377,496,377,496,389,469,389",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "579,377,606,377,606,389,579,389",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "690,375,717,375,717,387,690,387",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "791,375,843,375,843,387,791,387",
				"score": 1.0,
				"words": "2,515.55"
			}],
			[{
				"quad": "85,403,345,403,345,417,85,417",
				"score": 1.0,
				"words": "加：公允价值变动收益(损失以“-”号填列)"
			}, {
				"quad": "410,400,494,397,495,411,411,414",
				"score": 1.0,
				"words": "-2,137,412.65"
			}, {
				"quad": "523,399,605,399,605,411,523,411",
				"score": 1.0,
				"words": "-3,205,541.83"
			}, {
				"quad": "637,399,717,396,717,409,637,412",
				"score": 1.0,
				"words": "2,206,000.00"
			}, {
				"quad": "765,397,843,397,843,409,765,409",
				"score": 1.0,
				"words": "7,417,403.44"
			}],
			[{
				"quad": "85,426,267,426,267,440,85,440",
				"score": 1.0,
				"words": "投资收益(损失以“-”号填列)"
			}, {
				"quad": "411,422,494,422,494,434,411,434",
				"score": 1.0,
				"words": "-2,787,014.20"
			}, {
				"quad": "527,421,605,421,605,432,527,432",
				"score": 1.0,
				"words": "5,966,880.69"
			}, {
				"quad": "634,421,715,421,715,432,634,432",
				"score": 1.0,
				"words": "-1,159,083.57"
			}, {
				"quad": "757,421,843,417,843,430,758,434",
				"score": 1.0,
				"words": "41,547,621.28"
			}],
			[{
				"quad": "85,448,320,448,320,462,85,462",
				"score": 1.0,
				"words": "其中：对联营企业和合营企业的投资收益"
			}, {
				"quad": "469,444,496,444,496,456,469,456",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,444,606,444,606,454,581,454",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,442,719,442,719,454,692,454",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,440,845,440,845,454,818,454",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "85,470,267,470,267,484,85,484",
				"score": 1.0,
				"words": "汇兑收益(损失以“-”号填列)"
			}, {
				"quad": "469,466,496,466,496,478,469,478",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,466,606,466,606,476,581,476",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,464,719,464,719,476,692,476",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,464,845,464,845,476,818,476",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "85,492,295,492,295,506,85,506",
				"score": 1.0,
				"words": "三、营业利润(亏损以“-”号填列)"
			}, {
				"quad": "417,488,494,488,494,500,417,500",
				"score": 1.0,
				"words": "3,872,046.40"
			}, {
				"quad": "528,489,605,489,605,499,528,499",
				"score": 1.0,
				"words": "8,060,253.32"
			}, {
				"quad": "639,486,715,486,715,498,639,498",
				"score": 1.0,
				"words": "8,069,591.71"
			}, {
				"quad": "758,486,841,486,841,498,758,498",
				"score": 1.0,
				"words": "24,889,583.11"
			}],
			[{
				"quad": "85,514,176,514,176,528,85,528",
				"score": 1.0,
				"words": "加：营业外收入"
			}, {
				"quad": "471,510,496,510,496,522,471,522",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,510,608,510,608,520,581,520",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,508,719,508,719,520,692,520",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,508,845,508,845,520,818,520",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "85,536,176,536,176,550,85,550",
				"score": 1.0,
				"words": "减：营业外支出"
			}, {
				"quad": "471,532,496,532,496,544,471,544",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,532,608,532,608,542,581,542",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,530,719,530,719,542,692,542",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,530,845,530,845,542,818,542",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "85,558,242,558,242,572,85,572",
				"score": 1.0,
				"words": "其中：非流动资产处置损失"
			}, {
				"quad": "471,554,496,554,496,566,471,566",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,554,608,554,608,566,581,566",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,552,719,552,719,564,692,564",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,552,845,552,845,564,818,564",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "87,580,322,580,322,594,87,594",
				"score": 1.0,
				"words": "四、利润总额(亏损总额以“-”号填列)"
			}, {
				"quad": "419,578,496,578,496,590,419,590",
				"score": 1.0,
				"words": "3,872,046.40"
			}, {
				"quad": "529,576,606,576,606,588,529,588",
				"score": 1.0,
				"words": "8,060,253.32"
			}, {
				"quad": "639,576,717,576,717,588,639,588",
				"score": 1.0,
				"words": "8,069,591.71"
			}, {
				"quad": "759,575,843,573,843,586,760,588",
				"score": 1.0,
				"words": "24,889,583.11"
			}],
			[{
				"quad": "85,604,176,604,176,618,85,618",
				"score": 1.0,
				"words": "减：所得税费用"
			}, {
				"quad": "430,600,496,600,496,612,430,612",
				"score": 1.0,
				"words": "968,011.60"
			}, {
				"quad": "529,600,606,600,606,612,529,612",
				"score": 1.0,
				"words": "2,015,063.33"
			}, {
				"quad": "639,598,717,598,717,610,639,610",
				"score": 1.0,
				"words": "1,470,889.28"
			}, {
				"quad": "765,598,843,598,843,610,765,610",
				"score": 1.0,
				"words": "4,142,755.87"
			}],
			[{
				"quad": "87,626,308,626,308,640,87,640",
				"score": 1.0,
				"words": "五、净利润(净亏损以“-”号填列)*"
			}, {
				"quad": "419,624,496,624,496,634,419,634",
				"score": 1.0,
				"words": "2,904,034.80"
			}, {
				"quad": "529,622,606,622,606,634,529,634",
				"score": 1.0,
				"words": "6,045,189.99"
			}, {
				"quad": "639,622,717,620,717,633,639,635",
				"score": 1.0,
				"words": "6,598,702.43"
			}, {
				"quad": "760,620,843,620,843,632,760,632",
				"score": 1.0,
				"words": "20,746,827.24"
			}],
			[{
				"quad": "87,648,256,648,256,662,87,662",
				"score": 1.0,
				"words": "归属于母公司所有者的净利润"
			}, {
				"quad": "419,646,496,646,496,658,419,658",
				"score": 1.0,
				"words": "2,904,034.80"
			}, {
				"quad": "529,644,606,644,606,656,529,656",
				"score": 1.0,
				"words": "6,045,189.99"
			}, {
				"quad": "639,644,717,644,717,656,639,656",
				"score": 1.0,
				"words": "6,598,702.43"
			}, {
				"quad": "760,642,843,642,843,654,760,654",
				"score": 1.0,
				"words": "20,746,827.24"
			}],
			[{
				"quad": "87,672,165,672,165,684,87,684",
				"score": 1.0,
				"words": "少数股东损益"
			}, {
				"quad": "471,668,498,668,498,678,471,678",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "581,666,608,666,608,678,581,678",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "692,666,719,666,719,678,692,678",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "818,664,847,664,847,676,818,676",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "87,694,171,694,171,705,87,705",
				"score": 1.0,
				"words": "六、每股收益："
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}],
			[{
				"quad": "93,713,203,713,203,727,93,727",
				"score": 1.0,
				"words": "(一)基本每股收益"
			}, {
				"quad": "471,711,498,711,498,721,471,721",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,709,608,709,608,721,583,721",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}],
			[{
				"quad": "93,737,205,737,205,749,93,749",
				"score": 1.0,
				"words": "(二)稀释每股收益"
			}, {
				"quad": "471,731,498,731,498,743,471,743",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,731,610,731,610,743,583,743",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,731,721,731,721,741,694,741",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "820,729,847,729,847,741,820,741",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "87,755,205,755,205,769,87,769",
				"score": 1.0,
				"words": "加：年初未分配利润"
			}, {
				"quad": "471,755,498,755,498,767,471,767",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "525,755,608,752,609,765,525,769",
				"score": 1.0,
				"words": "19,734,169.43"
			}, {
				"quad": "641,753,719,753,719,765,641,765",
				"score": 1.0,
				"words": "2,754,133.90"
			}, {
				"quad": "767,751,845,751,845,765,767,765",
				"score": 1.0,
				"words": "2,754,133.90"
			}],
			[{
				"quad": "89,779,167,779,167,793,89,793",
				"score": 1.0,
				"words": "七、利润分配"
			}, {
				"quad": "473,777,498,777,498,789,473,789",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,777,610,777,610,789,583,789",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,775,721,775,721,787,694,787",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "767,775,843,775,843,787,767,787",
				"score": 1.0,
				"words": "1,886,670.61"
			}],
			[{
				"quad": "89,801,186,801,186,815,89,815",
				"score": 1.0,
				"words": "1、提取盈余公积"
			}, {
				"quad": "473,799,498,799,498,811,473,811",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,799,610,799,610,811,583,811",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,799,721,799,721,809,694,809",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "767,797,843,797,843,809,767,809",
				"score": 1.0,
				"words": "1,886,670.61"
			}],
			[{
				"quad": "89,823,211,823,211,837,89,837",
				"score": 1.0,
				"words": "2、提取一般风险准备"
			}, {
				"quad": "473,823,498,823,498,835,473,835",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,821,610,821,610,833,583,833",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,821,721,821,721,833,694,833",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "820,819,847,819,847,831,820,831",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,845,265,845,265,859,89,859",
				"score": 1.0,
				"words": "3、对所有者(或股东)的分配"
			}, {
				"quad": "473,845,500,845,500,857,473,857",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,843,610,843,610,855,583,855",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,843,721,843,721,855,694,855",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "820,843,847,843,847,855,820,855",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,869,136,869,136,883,89,883",
				"score": 1.0,
				"words": "4、其他"
			}, {
				"quad": "473,867,500,867,500,879,473,879",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,867,610,867,610,877,583,877",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,865,721,865,721,877,694,877",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "820,865,847,865,847,877,820,877",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,891,233,891,233,905,89,905",
				"score": 1.0,
				"words": "八、所有者权益内部结转"
			}, {
				"quad": "473,891,500,891,500,901,473,901",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,889,610,889,610,899,583,899",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,887,721,887,721,899,694,899",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "820,887,849,887,849,899,820,899",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,913,213,913,213,927,89,927",
				"score": 1.0,
				"words": "1、盈余公积弥补亏损"
			}, {
				"quad": "473,911,500,911,500,923,473,923",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "583,911,610,911,610,923,583,923",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "694,909,721,909,721,921,694,921",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "822,909,849,909,849,921,822,921",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,935,136,935,136,949,89,949",
				"score": 1.0,
				"words": "2、其他"
			}, {
				"quad": "473,935,500,935,500,945,473,945",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "585,933,610,933,610,945,585,945",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "696,931,721,931,721,943,696,943",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "822,931,849,931,849,943,822,943",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "91,959,167,959,167,973,91,973",
				"score": 1.0,
				"words": "九、专项储备"
			}, {
				"quad": "0,0,0,0,0,0,0,0",
				"score": 1.0,
				"words": ""
			}, {
				"quad": "585,955,610,955,610,967,585,967",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "696,955,723,955,723,967,696,967",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "822,953,849,953,849,967,822,967",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "91,981,161,981,161,994,91,994",
				"score": 1.0,
				"words": "1、本期提取"
			}, {
				"quad": "473,979,500,979,500,990,473,990",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "585,979,610,979,610,990,585,990",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "696,977,723,977,723,988,696,988",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "822,977,849,977,849,988,822,988",
				"score": 1.0,
				"words": "0.00"
			}],
			[{
				"quad": "89,1001,183,1001,183,1020,89,1020",
				"score": 1.0,
				"words": "十、未分配利润"
			}, {
				"quad": "475,1002,500,1002,500,1014,475,1014",
				"score": 1.0,
				"words": "0.00"
			}, {
				"quad": "525,1002,610,999,611,1012,525,1016",
				"score": 1.0,
				"words": "25,779,359.42"
			}, {
				"quad": "643,1000,721,1000,721,1012,643,1012",
				"score": 1.0,
				"words": "9,352,836.33"
			}, {
				"quad": "761,1000,847,997,847,1010,762,1014",
				"score": 1.0,
				"words": "21,614,290.53"
			}]
		],
		"description": "利润表",
		"type": 2
	}],
	"rotation": 0
}


//////////////////
// WEBPACK FOOTER
// ./static/preview_data/financial_report.js
// module id = null
// module chunks = 